import { buildCSV } from '@mui/x-data-grid/hooks/features/export/serializers/csvSerializer';
import { defaultGetRowsToExport, getColumnsToExport } from '@mui/x-data-grid/hooks/features/export/utils';
import { exportAs } from '@mui/x-data-grid/utils/exportAs';

const escapeTextFormula = (value) => (
    typeof value === 'string' && /^[=+\-@\t\r\n]/.test(value) ? `'${value}` : value
);

// MUI 6 quotes delimiter/newline cells before escaping formulas. Adapt the
// export-only cell snapshot before that serializer runs, retaining MUI's
// column/row selection, formatting, quoting, BOM and download behavior.
export default function exportGridCsv(apiRef, options, ignoreValueFormatter = false) {
    // These are the installed MUI export helpers, not a second implementation
    // of selection/filtering. Keep this adapter covered when upgrading MUI.
    const exportApiRef = { current: {
        ...apiRef.current,
        getCellParams: (...args) => {
            const cell = apiRef.current.getCellParams(...args);
            return { ...cell, value: escapeTextFormula(cell.value), formattedValue: escapeTextFormula(cell.formattedValue) };
        },
        unstable_getAllGroupDetails: () => Object.fromEntries(Object.entries(apiRef.current.unstable_getAllGroupDetails()).map(([id, group]) => (
            [id, { ...group, headerName: escapeTextFormula(group.headerName || group.groupId) }]
        ))),
    } };
    const csv = buildCSV({
        apiRef: exportApiRef,
        columns: getColumnsToExport({ apiRef, options }).map(column => ({ ...column, headerName: escapeTextFormula(column.headerName || column.field) })),
        rowIds: defaultGetRowsToExport({ apiRef }),
        ignoreValueFormatter,
        csvOptions: { delimiter: ',', shouldAppendQuotes: true, includeHeaders: true, includeColumnGroupsHeaders: true, escapeFormulas: false },
    });
    const blob = new Blob([options.utf8WithBom ? new Uint8Array([0xef, 0xbb, 0xbf]) : '', csv], { type: 'text/csv' });
    exportAs(blob, 'csv', options.fileName);
}
